import {AppleRepository} from '@infra/domain/model/Apple/InvertaseAppleRepository';
import {ApiAuthRepository} from '@infra/domain/model/Auth/ApiAuthRepository';
import {RefreshSession} from '@application/Auth/RefreshSession';

import {GetLoginInfo} from './GetLoginInfo';
import {LoginWithGoogle} from './LoginWithGoogle';
import {IsFirstLogin} from './IsFirstLogin';
import {IsLoggedIn} from './IsLoggedIn';
import {Login} from './Login';
import {RecoverPassword} from './RecoverPassword';
import {RegisterUser} from './RegisterUser';
import {SetHasLoggedIn} from './SetHasLoggedIn';
import {ApplyFirstSession, ClearFirstSession, IsFirstSession} from './FirstSession';
import {LoginWithFaceBook} from '@application/Auth/LoginWithFaceBook';
import {RegisterWithFaceBook} from '@application/Auth/RegisterWithFaceBook';
import {LoginWithApple} from '@application/Auth/LoginWithApple';

const apple = LoginWithApple(ApiAuthRepository, AppleRepository);

export const AuthApplication = {
  login: Login(ApiAuthRepository),
  isLoggedIn: IsLoggedIn(ApiAuthRepository),
  isFirstLogin: IsFirstLogin(),
  loginWithGoogle: LoginWithGoogle(ApiAuthRepository),
  recoverPassword: RecoverPassword(ApiAuthRepository),
  registerUser: RegisterUser.bind(null, ApiAuthRepository),
  getLoginInfo: GetLoginInfo.bind(null, ApiAuthRepository),
  setHasLoggedIn: SetHasLoggedIn(),
  refreshSession: RefreshSession(),
  applyFirstSession: ApplyFirstSession(),
  clearFirstSession: ClearFirstSession(),
  isFirstSession: IsFirstSession(),
  loginWithFaceBook: LoginWithFaceBook(ApiAuthRepository),
  registerWithFaceBook: RegisterWithFaceBook(ApiAuthRepository),
  isAppleLoginSupported: apple.isAppleLoginSupported,
  getAppleToken: apple.getAccessToken,
  loginWithApple: apple.login,
};
